import Field from '../Field';

/*
  http://stackoverflow.com/questions/123559/a-comprehensive-regex-for-phone-number-validation
  Modified to make area code required
 */
const regex = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[0-9]|[2-9][0-8]1|[2-9][0-8][0-9])\s*\)|([2-9]1[0-9]|[2-9][0-8]1|[2-9][0-8][0-9]))\s*(?:[.-]\s*)?)([1-9]1[0-9]|[1-9][0-9]1|[2-9][0-9][0-9])\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/i;

class Phone extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (val === undefined || val === null) {
        val = '';
        this.setValue(val, index);
        this.setDisplayValue(val, index);
        return;
      }

      const matches = val.match(regex);
      if (matches && (matches[1] || matches[2]) && matches[3] && matches[4]) {
        if (force || this.validIndex[index]) {
          /*
           * prefix - Based on regex group 1 or 2 will be the first 3 digits
           * of the phone number
           */
          const prefix = matches[1] || matches[2];
          const saneValue = `${prefix}${matches[3]}${matches[4]}`;
          this.setValue(saneValue, index);

          const displayValue = `(${prefix}) ${matches[3]}-${matches[4]}`;
          this.setDisplayValue(displayValue, index);
        }
      }
    });

    return this;
  }

  validate() {
    this.sanitize(true); // Sanitize first so we don't get maxlength violations
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      if (!regex.test(val)) {
        this.invalidate('Invalid phone number.', index);
      }
    });

    return this.isValid();
  }
}

export default Phone;
